import { useEffect, useState } from 'react';
import { Button, Flex, Input, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { getVehicleByPlate } from '@features/vehicles/services/vehiclesService';

const { Text } = Typography;

export const InputPlate = ({ value, disabled, onChange, onVehicleByPlateQuery, validator }) => {
  const [plate, setPlate] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const [searchStatus, setSearchStatus] = useState(null); // null | 'success' | 'error' | 'format-error' | 'required'

  useEffect(() => {
    if (disabled) setSearchStatus(null);
  }, [disabled]);

  const validateFormat = (val) => {
    if (!val) {
      setSearchStatus('required');
      return;
    }
    validator?.(val)
      .then(() => setSearchStatus(null))
      .catch(() => setSearchStatus('format-error'));
  };

  const handleChange = (e) => {
    const upperValue = e.target.value.toUpperCase();
    setPlate(upperValue);
    onChange?.({ ...e, target: { ...e.target, value: upperValue } });
    validateFormat(upperValue);
  };

  const handleFocus = () => {
    if (!plate) setSearchStatus('required');
  };

  const handleSearch = async () => {
    if (!plate) {
      setSearchStatus('required');
      return;
    }

    try {
      await validator?.(plate);
    } catch {
      setSearchStatus('format-error');
      return;
    }

    setIsFetching(true);
    setSearchStatus(null);
    onVehicleByPlateQuery?.({ isFetching: true });

    try {
      const data = await getVehicleByPlate({ plate });

      if (data?.fasecoldaCode) {
        setSearchStatus('success');
        onVehicleByPlateQuery?.({ data, isFetching: false, isError: false });
      } else {
        setSearchStatus('error');
        onVehicleByPlateQuery?.({ data: undefined, isFetching: false, isError: true });
      }
    } catch (error) {
      setSearchStatus('error');
      onVehicleByPlateQuery?.({ data: undefined, isFetching: false, isError: true, error });
    }

    setIsFetching(false);
  };

  return (
    <Flex vertical gap={6}>
      <Flex gap={8}>
        <Input
          style={{ flex: 1 }}
          value={value}
          placeholder={disabled ? 'Placa' : 'Ingresar placa'}
          onChange={handleChange}
          onFocus={handleFocus}
          onPressEnter={handleSearch}
          readOnly={isFetching}
          disabled={disabled}
        />
        <Button
          type='primary'
          icon={<SearchOutlined />}
          onClick={handleSearch}
          loading={isFetching}
          disabled={disabled}
        >
          Buscar
        </Button>
      </Flex>
      {searchStatus === 'success' && (
        <Text type='success' style={{ fontSize: '0.9em' }}>
          Información encontrada correctamente
        </Text>
      )}
      {searchStatus === 'required' && (
        <Text type='danger' ellipsis={{ tooltip: { color: 'red' } }} style={{ fontSize: '0.9em' }}>
          Este campo es obligatorio
        </Text>
      )}
      {searchStatus === 'format-error' && (
        <Text type='danger' ellipsis={{ tooltip: { color: 'red' } }} style={{ fontSize: '0.9em' }}>
          El formato de la placa no es válido
        </Text>
      )}
      {searchStatus === 'error' && (
        <Text type='danger' ellipsis={{ tooltip: { color: 'red' } }} style={{ fontSize: '0.9em' }}>
          La placa del vehículo no fue encontrada
        </Text>
      )}
    </Flex>
  );
};
